import styled from "styled-components";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import Textarea from "../Textarea";

type RejectModalProp = {
  setOpenOrClose: () => void;
  onRejectCall: () => void;
  onCommentChange: (e: any) => void;
  comment: string;
  error: string;
};

const RejectModal = ({
  setOpenOrClose,
  onRejectCall,
  onCommentChange,
  comment,
  error,
}: RejectModalProp) => {
  return (
    <StyledRejectModal>
      <RejectModalHeader>
        <HeaderTitle>Reject Membership</HeaderTitle>
        <Close
          src={require("../../assets/images/ei_close.png")}
          alt="close"
          onClick={setOpenOrClose}
        />
      </RejectModalHeader>
      <RejectModalBody>
        <Textarea
          placeholder="Add Comment"
          label="Comment"
          required
          onChange={onCommentChange}
          value={comment}
          error={error ? true : false}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <ButtonWrapper>
          <Button
            label="Submit"
            variant="filled"
            color={Colors.appleRed}
            size="medium"
            isRounded={true}
            onClick={() => {
              onRejectCall();
            }}
          />
        </ButtonWrapper>
      </RejectModalBody>
    </StyledRejectModal>
  );
};

export default RejectModal;

const StyledRejectModal = styled.div`
  padding: 1.625rem 2.2rem 1.8rem 2.25rem;
`;
const RejectModalHeader = styled.div`
  display: flex;
  justify-content: center;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  transform: translate(3.375rem, -0.25rem);
  cursor: pointer;
`;
const RejectModalBody = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
`;
const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;

const ErrorMessage = styled.div`
  font-family: "Poppins-Book";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  padding-top: 0.5rem;
`;
